import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { normalizeRecentAddressSuggestionsResponse } from './mostRecentAddressResponse.utils';
import { API_SERVER_URL, V3_APP_BASE_URL } from '@/constants/Config';
import type {
  IMostRecentAddress,
  IRecentAddressSuggestion,
} from '@/common/interfaces/mostRecent.interface';

/** Defining a service using a base URL and expected endpoints  */
export const mostRecentAdressApi = createApi({
  reducerPath: 'mostRecentAddressApi',
  tagTypes: ['MostRecentAddress'],
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  endpoints: (build) => ({
    getMostRecentAddress: build.query<IMostRecentAddress, void>({
      query: () => ({ url: `api/cp/most-recent/address`, method: 'get' }),
      providesTags: ['MostRecentAddress'],
    }),
    getRecentAddressSuggestions: build.query<IRecentAddressSuggestion[], number>({
      query: (clientId) => ({
        url: `${API_SERVER_URL}api/order/suggestions/address/${clientId}`,
        method: 'get',
      }),
      transformResponse: (response: unknown) => normalizeRecentAddressSuggestionsResponse(response),
    }),
  }),
});

/** Export hooks for usage in functional components, which are auto-generated based on the defined endpoints */
export const {
  useGetMostRecentAddressQuery,
  useLazyGetMostRecentAddressQuery,
  useGetRecentAddressSuggestionsQuery,
  util,
} = mostRecentAdressApi;
